import { Box } from '@mui/material';
import React from 'react';
import { ActionButton } from '../../ActionButton';
export const MainActionsSmall = (props) => {
    if (props.mainAction && props.secondaryAction) {
        return (React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2 } },
            React.createElement(ActionButton, { action: props.mainAction, variant: 'contained', sx: { flexGrow: 1 }, "default-data-test": 'main-action-button' }),
            React.createElement(ActionButton, { action: props.secondaryAction, variant: 'outlined', sx: { flexGrow: 1 }, "default-data-test": 'secondary-action-button' })));
    }
    else if (props.mainAction) {
        return React.createElement(ActionButton, { action: props.mainAction, fullWidth: true, variant: 'contained', "default-data-test": 'main-action-button' });
    }
    else if (props.secondaryAction) {
        return React.createElement(ActionButton, { action: props.secondaryAction, fullWidth: true, variant: 'outlined', "default-data-test": 'secondary-action-button' });
    }
    else {
        return null;
    }
};
